import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import AppleBannerHelpers from "helpers/apple-banner-helpers";
import { browserPropType } from "components/propTypes";
import AtomHed from "components/source/atoms/atom-hed";
import AtomDek from "components/source/atoms/atom-dek";
import ClosableModal from "components/source/shared/closable-modal";
import sharedActions from "actions/shared-actions";
import MembershipProgressIndicator from "components/source/membership/onboarding/MembershipProgressIndicator";
import BackArrow from "images/sprites/reb/svg/back_arrow_heavy.svg";

const baseClass = "multi-panel-modal";

class MultiPanelModal extends React.Component {
  static baseClass = baseClass;

  static propTypes = {
    browser: browserPropType,
    className: PropTypes.string,
    dispatch: PropTypes.func,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isBottomStickyMobile: PropTypes.bool,
    modalName: PropTypes.string,
    onClickBackButton: PropTypes.func,
    onRequestClose: PropTypes.func,
    panels: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.element,
          dek: PropTypes.element,
          hed: PropTypes.element,
          key: PropTypes.string.isRequired,
        })
      ),
    ]),
    panelKeys: PropTypes.arrayOf(PropTypes.string),
    progressBarSteps: PropTypes.number,
    showProgressBar: PropTypes.bool,
    translation: PropTypes.number,
    width: PropTypes.number,
  };

  state = {
    bottomPosition: this.appleBannerHeight(),
  };

  componentDidMount() {
    this.boundSetButtonPosition = this.setButtonPosition.bind(this);
    window.addEventListener("resize", this.boundSetButtonPosition);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.boundSetButtonPosition);
  }

  appleBannerHeight() {
    return `${AppleBannerHelpers.appleBannerHeight()}px`;
  }

  setButtonPosition() {
    this.setState({ bottomPosition: this.appleBannerHeight() });
  }

  onRequestClose = () => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose();
    }

    this.props.dispatch(sharedActions.displayModal(false));
  };

  renderHed(hed) {
    if (!hed) {
      return;
    }
    /* eslint-disable react/jsx-props-no-spreading */
    return <AtomHed {...hed} />;
  }

  renderDek(dek) {
    if (!dek) {
      return;
    }
    return <AtomDek {...dek} />;
    /* eslint-enable react/jsx-props-no-spreading */
  }

  renderPanel = (panel, i) => {
    const { key, hed, dek, content } = panel;

    return (
      <div key={i} className={`${baseClass}__panel ${baseClass}__panel-${key}`}>
        {this.renderHed(hed)}
        {this.renderDek(dek)}
        <div className={`${baseClass}__content`}>{content}</div>
      </div>
    );
  };

  renderPanels() {
    return _.map(this.props.panels, this.renderPanel);
  }

  clickBackButton = () => {
    const index = this.props.translation;
    const prevPanel = this.props.panelKeys[index - 1];
    this.props.onClickBackButton(prevPanel);
  };

  renderProgressBar() {
    if (!this.props.showProgressBar) {
      return;
    }

    if (!this.props.translation) {
      return null;
    }

    return (
      <div className="superbar-progress" role="progressbar">
        <button className="left-arrow" onClick={this.clickBackButton} aria-label="previous">
          <BackArrow />
        </button>
        <MembershipProgressIndicator
          currentIndex={this.props.translation}
          paddingPercentageBetweenLines={1}
          strokeWidth={4}
          totalSteps={this.props.progressBarSteps}
        />
        <div className="slide-index">
          {this.props.translation}/{this.props.progressBarSteps}
        </div>
      </div>
    );
  }

  render() {
    const xIndex = (_.keys(this.props.panels).length - 1) * -100;
    const transformation = `translate3d(${xIndex}%, 0, 0)`;
    const style = {
      transform: transformation,
    };
    const additionalStyles =
      this.props.browser.isMobileViewport && this.props.isBottomStickyMobile
        ? { content: { bottom: this.state.bottomPosition } }
        : {};

    return (
      <ClosableModal
        additionalStyles={additionalStyles}
        isOpen={this.props.displayedModal === this.props.modalName}
        optionalClass={`${baseClass} auto-modal ${this.props.className} grid-superbar modal-close-circle`}
        onRequestClose={this.onRequestClose}>
        <div className={`${baseClass}-wrapper`}>
          <div className={`${baseClass}__panels`} style={style}>
            {this.renderPanels()}
          </div>
        </div>
        {this.renderProgressBar()}
      </ClosableModal>
    );
  }
}

export default MultiPanelModal;
